import NotesIcon from '@image/notes-menu-icon.svg';
import SettingsIcon from '@image/settings-menu-icon.svg';
import { NavigationPages } from '@ax/constants';

export const sidebarNavData = [
  {
    title: 'Notes',
    page: NavigationPages.Notes,
    icon: NotesIcon,
  },
  {
    title: 'Settings',
    page: NavigationPages.Settings,
    icon: SettingsIcon,
  },
];
